import { defineComponent as _defineComponent } from 'vue'
import { EstateInterface } from "@/types/EstateInterface";
  import HeaderWithEstateLogo from "../ui/HeaderWithEstateLogo.vue";
  import { computed } from "vue";
  import Stepper from "../ui/Stepper.vue";
  import StepperLine from "../ui/StepperLine.vue";
  import store from "@/store";
  import {
    CustomizeHouseStepsEnum,
    CustomizeHouseStepsReviewQuoteEnum,
  } from "@/enums/CustomizeHouseSteps";
  import QuoteRequestCounter from "./QuoteRequestCounter.vue";
  import { StepTypeEnum } from "@/enums/BuilderStepType";

  interface Props {
    estate: EstateInterface;
    builderLogo: string;
    isReviewQuote?: boolean;
    skipStepIndex?: number;
  }

export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderMobileHeader',
  props: {
    estate: {},
    builderLogo: {},
    isReviewQuote: { type: Boolean },
    skipStepIndex: {}
  },
  emits: ["onRequestQuotes"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emits = __emit;
  const selectedQuote = computed(() => {
    return store.getters["builder/getSelectedSelection"];
  });

  
const __returned__ = { props, emits, selectedQuote, get EstateInterface() { return EstateInterface }, HeaderWithEstateLogo, computed, Stepper, StepperLine, get store() { return store }, get CustomizeHouseStepsEnum() { return CustomizeHouseStepsEnum }, get CustomizeHouseStepsReviewQuoteEnum() { return CustomizeHouseStepsReviewQuoteEnum }, QuoteRequestCounter, get StepTypeEnum() { return StepTypeEnum } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})